import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5 10.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M10.5 3a7.5 7.5 0 1 0 4.55 13.463l4.243 4.244a1 1 0 0 0 1.414-1.414l-4.244-4.244A7.5 7.5 0 0 0 10.5 3",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }